<template>
<v-main>
  <v-layout class="ma-2" justify-center>
    <v-card class="px-4 rounded-xl" width="1200">
      <v-card-title>
        Alterar dados Médico
      </v-card-title>
      <v-divider class="mb-2" />
      <v-text-field v-model="username" disabled :type="'text'" name="input-10-1" label="Login" counter @click:append="show1 = !show1"></v-text-field>
      <v-form v-model="valid" ref="form">

        <v-text-field disabled label="Nome completo" v-model="nome" :rules="nameRules" required></v-text-field>

        <!-- <v-autocomplete v-model="idLocalEscolhido" item-value="idLocal" item-text="nomeLocal" :items="listaLocais" :readonly="!isEditing" label="Local" :rules="[(v) => !!v || 'Adicione uma Local !!']" persistent-hint required>
        </v-autocomplete> -->

        <div>
          <v-text-field v-model="novaSenha" :append-icon="show1 ? 'visibility' : 'visibility_off'" :rules="senhaRules" :type="show1 ? 'text' : 'password'" label="Senha" counter @click:append="show1 = !show1"></v-text-field>
        </div>

        <div>
          <v-text-field v-model="novaSenha1" :append-icon="show2 ? 'visibility' : 'visibility_off'" :rules="senha1Rules" :type="show2 ? 'text' : 'password'" label="Confirme a Senha" counter @click:append="show2 = !show2"></v-text-field>
        </div>

        <v-alert :value="erroLogin" color="error" icon="warning" outlined>
          Username já existente!
        </v-alert>

        <v-alert :value="sucessoLogin" color="success" icon="check_circle" outlined>
          Senha alterada com sucesso!
        </v-alert>
        <v-card-actions>
          <v-spacer />
          <v-btn rounded dark @click="submit" :class="{ red: !valid, green: valid }">Salvar</v-btn>
          <v-btn rounded outlined to='/listaMedicosUnidade'>
            <v-icon left>keyboard_backspace</v-icon>
            voltar
          </v-btn>
        </v-card-actions>
      </v-form>

    </v-card>

  </v-layout>

</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import FormularioComLocais from './../../../assets/components/FormularioComLocais'
import administradorUnidadeService from '../../../services/administradorUnidade.service'
import medicoService from '../../../services/medico.service'
var sha1 = require('sha1')
export default {
  name: 'cadastrarAtendenteUnidade',
  components: {
    FormularioComLocais
  },
  data () {
    return {
      show1: false,
      show2: false,
      valid: false,
      tipo: 2,
      idLocalEscolhido: '',
      erroLogin: false,
      login: '',
      sucessoLogin: false,
      novaSenha: '',
      novaSenha1: '',
      respostaServidor: '',
      idUnidadeEscolhida: '',
      username: '',
      nome: '',
      idMedico: '',
      listaLocais: [],
      isEditing: true,
      rules: {
        min: v => v.length >= 8 || 'minimo 8 caracteres'
      },
      senhaRules: [
        (v) => v && v.length > 5 || 'A Senha deve ter mais de 6 caracteres'
      ],
      senha1Rules: [
        (v) => v && v.length > 5 || 'A Senha deve ter mais de 6 caracteres',
        (v) => v === this.novaSenha || 'As senhas devem ser iguais'
      ],
      nameRules: [
        (v) => !!v || 'Nome obrigatório',
        (v) => v && v.length > 2 || 'Nome deve ter mais de 2 caracteres '
      ],
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false,
      checkboxSenha: false
    }
  },

  methods: {

    retornarLocais () {
      console.log('em retornar unidades adm...')
      administradorUnidadeService.administradorUnidade
        .retornarLocais()
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
          this.listaLocais = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    clear () {
      this.$refs.form.reset()
      this.erroLogin = false
    },

    submit () {
      if (this.$refs.form.validate()) {
        this.sucessoLogin = false
        this.erroLogin = false

        console.log('form valido' + this.idMedico + '   --   ' + sha1(this.novaSenha))
        medicoService.medico.alterarSenha({ idMedico: this.idMedico, senha: sha1(this.novaSenha) })
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data.status)
            if (rsp.data == 'usernameExistente') {
              this.erroLogin = true
            }
            if (rsp.data.status == 'success') {
              this.sucessoLogin = true
              this.clear()
              setTimeout(() => this.$router.push({
                path: '/listaMedicosUnidade'
              }), 2000)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    limpar () {
      this.senha = ''
      this.nome = ''
      this.idUnidadeEscolhida = ''
    }

  },
  created () {
    console.log('created...')
  },
  mounted () {
    console.log('em mounted lista unid...')
    // console.log(this.user);
    if (!this.$route.params.medico) {
      this.$router.push('/listaMedicosUnidade')
      return
    }

    this.limpar()
    this.user = this.$store.getters.usuario
    // this.retornarLocais()
    this.username = this.$route.params.medico.username
    this.nome = this.$route.params.medico.nome
    this.idMedico = this.$route.params.medico.idMedico
  }
}
</script>
